import { Component } from 'react';
import { downloadFloorPlan } from '../../../util/all';

export default class FloorPlan extends Component<any, any> {
  switchPlan: any;

  constructor(props: any) {
    super(props);
    this.switchPlan = props.switchPlan.bind(this);
  }

  onPlanClick(url: string, index: number) {
    this.switchPlan(url, index);
  }

  async downloadPdf(url: string) {
    const {
      tour: { floorPlans },
      selectedPlan,
    } = this.props;
    const plan = floorPlans.find((floorPlan) => floorPlan.url === selectedPlan);
    await downloadFloorPlan(url, plan);
  }

  render() {
    return (
      <div className="section floorPlans w-100 h-100">
        <div className="plans">
          <div className="container" style={{ display: 'flex' }}>
            {this.props.tour.floorPlans.map((plan: any, i: number) => (
              <span
                style={
                  plan.name && plan.name.length > 0
                    ? { display: 'inline-block' }
                    : { display: 'none' }
                }
                className={plan.selected ? 'selected' : ''}
                key={i}
                onClick={this.onPlanClick.bind(this, plan.url, i)}
              >
                {plan.name}
              </span>
            ))}
          </div>
        </div>
        {this.props.selectedPlan && (
          <div
            className={this.props.imgLong ? 'plan w-100 h-75' : 'plan w-100 h-67'}
            style={{
              backgroundImage: `url(${process.env.NEXT_PUBLIC_CDN}/tours/${
                this.props.tour.id
              }/floorplans/${this.props.selectedPlan.split('.')[0]}.webp)`,
            }}
          />
        )}
        <div className="d-flex justify-content-center">
          <div>
            <a
              className="square-button"
              onClick={() =>
                this.downloadPdf(
                  `${process.env.NEXT_PUBLIC_CDN}/tours/${this.props.tour.id}/floorplans/${this.props.selectedPlan}`,
                )
              }
            >
              <i className="fas fa-file-pdf" />
              {this.props.tour.client && this.props.tour.client.rtl ? 'הורד PDF' : 'Download PDF'}
            </a>
          </div>
        </div>
      </div>
    );
  }
}
